import withInputErrorMessage from '../withInputErrorMessage';
import withSelectFormik from './withSelectFormik';
import { SelectRemoteBase } from './remoteOptionSelectFactory';

export default withSelectFormik(withInputErrorMessage(SelectRemoteBase));
